<app-menu></app-menu>

<div class="simulator-hero">
  <div class="container text-center">
    <h1>Quer saber o valor de venda do seu livro?</h1>
    <p>Preencha os campos abaixo para simular valor de venda e o custo do seu livro.</p>
  </div>
</div>

<div class="simulator-container">
  <div class="container">
    
    <ng-container *ngIf="isLoadingConfig; else mainContent">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    </ng-container>

    <ng-template #mainContent>
      <div class="simulator-layout row">
        
        <!-- COLUNA ESQUERDA: FORMULÁRIO -->
        <div class="col-12 col-lg-7 form-column">
          <form [formGroup]="model">
            
            <div class="form-section">
              <h3>Quantidade de páginas</h3>
              <p class="section-desc">Informe o número de páginas do miolo do seu livro.</p>
              
              <div class="input-group-custom">
                <input type="number" formControlName="pages" class="form-control form-control-lg custom-input" 
                       placeholder="Ex: 150" (input)="onPagesChange()" min="20">
                <div *ngIf="model.get('pages')?.invalid && (model.get('pages')?.dirty || model.get('pages')?.touched)" class="error-text">
                  Mínimo de 20 páginas.
                </div>
              </div>
            </div>

            <div class="form-section">
              <h3>Formato do livro</h3>
              <p class="section-desc">Selecione as dimensões do livro impresso.</p>
              
              <div class="spinner-container-small" *ngIf="isLoadingPrints">
                <mat-spinner diameter="30"></mat-spinner>
              </div>

              <div class="formats-grid" *ngIf="!isLoadingPrints">
                <div class="format-card" *ngFor="let group of groupedPrints" 
                     [ngClass]="{'selected': selectedSizeGroup?.size === group.size}"
                     (click)="selectSizeGroup(group)">
                  <div class="format-icon">
                    <mat-icon>aspect_ratio</mat-icon>
                  </div>
                  <div class="format-name">{{ group.size }}</div>
                  <div class="format-desc">{{ group.variations.length }} {{ group.variations.length === 1 ? 'variação' : 'variações' }}</div>
                </div>
                
                <div *ngIf="groupedPrints.length === 0 && model.get('pages')?.valid" class="no-formats">
                  Nenhum formato disponível para esta quantidade de páginas.
                </div>
              </div>
            </div>

            <div class="form-section" *ngIf="selectedSizeGroup">
              <h3>Variação de impressão</h3>
              <p class="section-desc">Selecione o tipo de papel e acabamento.</p>

              <div class="formats-grid variations-grid">
                <div class="format-card variation-card" *ngFor="let print of selectedSizeGroup.variations" 
                     [ngClass]="{'selected': selectedPrint?.idBookPrint === print.idBookPrint}"
                     (click)="selectPrint(print)">
                  <div class="format-name variation-name">{{ print.bookPrintDescription }}</div>
                </div>
              </div>
            </div>

            <div class="form-section">
              <div class="mode-toggle">
                <div class="mode-option" [ngClass]="{'active': calcMode === 'profit'}" (click)="setCalcMode('profit')">
                  <mat-icon>monetization_on</mat-icon>
                  <span>Por Lucro</span>
                </div>
                <div class="mode-option" [ngClass]="{'active': calcMode === 'price'}" (click)="setCalcMode('price')">
                  <mat-icon>sell</mat-icon>
                  <span>Por Preço</span>
                </div>
              </div>

              <div *ngIf="calcMode === 'profit'" class="mt-4">
                <h3>Quanto quer receber por venda?</h3>
                <p class="section-desc">Defina o lucro que você deseja obter por cada livro vendido.</p>
                
                <div class="input-group-custom price-input">
                  <input type="text" formControlName="desiredProfit" class="form-control form-control-lg custom-input" 
                         (input)="onCurrencyInput($event, 'desiredProfit')" (blur)="onCurrencyBlur('desiredProfit')">
                </div>
              </div>

              <div *ngIf="calcMode === 'price'" class="mt-4">
                <h3>Por quanto quer vender seu livro?</h3>
                <p class="section-desc">Defina o preço de venda final para o leitor.</p>
                
                <div class="input-group-custom price-input">
                  <input type="text" formControlName="sellPrice" class="form-control form-control-lg custom-input" 
                         (input)="onCurrencyInput($event, 'sellPrice')" (blur)="onCurrencyBlur('sellPrice')">
                  <div class="hint-text">
                    Mínimo sugerido: {{ formatCurrency(minPrice) }}
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>

        <!-- COLUNA DIREITA: RESULTADOS -->
        <div class="col-12 col-lg-5 results-column">
          <div class="results-card sticky-top" style="top: 100px; z-index: 1;">
            <h2>Pré-visualização</h2>
            <p class="results-desc">Estimativa de custos e lucro por unidade vendida.</p>
            
            <div *ngIf="!selectedPrint" class="empty-results">
              <mat-icon>receipt_long</mat-icon>
              <p>Preencha as páginas e selecione um formato para ver os resultados.</p>
            </div>

            <div *ngIf="selectedPrint" class="results-content">
              
              <div class="result-row total-price">
                <span class="label">Preço de Venda</span>
                <span class="value">{{ formatCurrency(calculatedSellPrice) }}</span>
              </div>

              <div class="divider"></div>
              
              <div class="breakdown">
                <div class="result-row sub">
                  <span class="label">Preço para o Autor</span>
                  <span class="value text-danger">- {{ formatCurrency(productionCost + platformCost + taxCost) }}</span>
                </div>
              </div>

              <div class="divider"></div>

              <div class="result-row profit" [ngClass]="getEstimatedClass()">
                <div class="profit-label-group">
                  <span class="label">Seu Lucro Estimado</span>
                  <span class="margin-badge">{{ estimatedMargin | number:'1.0-1' }}% margem</span>
                </div>
                <span class="value">{{ formatCurrency(estimatedProfit) }}</span>
              </div>
              
              <div class="warning-msg" *ngIf="estimatedProfit <= 0">
                <mat-icon>warning</mat-icon>
                O preço atual não gera lucro. Aumente o valor de venda.
              </div>

              <button class="btn-publish-now" (click)="publicarAgora()">
                Publique seu livro agora
                <mat-icon>arrow_forward</mat-icon>
              </button>

              <p class="freight-disclaimer">* Os valores simulados não contemplam o custo do frete.</p>
            </div>
          </div>
        </div>

      </div>
    </ng-template>
    
  </div>
</div>

<div class="benefits-section">
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-md-6 benefit-item">
        <mat-icon>local_shipping</mat-icon>
        <h4>Venda em todo o Brasil</h4>
        <ul class="benefit-list">
          <li>Sem estoque</li>
          <li>Entregamos em qualquer lugar do Brasil</li>
          <li>Comissão sobre venda de seus livros</li>
        </ul>
      </div>
      <div class="col-md-6 benefit-item">
        <mat-icon>workspace_premium</mat-icon>
        <h4>Qualidade Editorial</h4>
        <ul class="benefit-list">
          <li>Padrão Qualis Capes</li>
          <li>ISBN registrado</li>
          <li>Ficha catalográfica</li>
          <li>Capa por Designer Capista e Diagramação do Miolo</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
